import URLS from "../../util/urls";
import axios from 'axios';

const state = {
  listaVistorias: []
}

const mutations = {
  atualizarListaVistorias(state, payload) {
    state.listaVistorias = payload;
  },

  excluirImagemDoState(state, payload) {
    const indexVistoria = state.listaVistorias.findIndex(vistoria => vistoria.id == payload.idVistoria);

    const indexComodo = state.listaVistorias[indexVistoria].comodos.findIndex(comodo => comodo.id == payload.idComodo);

    state.listaVistorias[indexVistoria].comodos[indexComodo].imagens.splice(payload.indexImagem, 1);
  },
}

const actions = {
  listarVistorias(context, payload) {
    return axios.post(URLS.VISTORIAS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarListaVistorias', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarVistorias', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  gravarComodos(context, payload) {
    return axios.post(URLS.VISTORIAS_GRAVAR_COMODOS, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {} , { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarComodos', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerComodo(context, payload) {
    return axios.post(URLS.VISTORIAS_REMOVER_COMODO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerComodo', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarImagem(context, payload) {
    return axios.post(URLS.VISTORIAS_GRAVAR_IMAGEM, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gravarImagem', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerImagem(context, payload) {
    return axios.post(URLS.VISTORIAS_REMOVER_IMAGEM, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerImagem', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  atualizarComodo(context, payload) {
    return axios.post(URLS.VISTORIAS_ATUALIZAR_COMODO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('atualizarComodo', payload);
            }
          }).catch(error => {
             throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  gravarItensComodo(context, payload) {
    return axios.post(URLS.VISTORIAS_GRAVAR_ITEM_COMODO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarItensComodo', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarDetalheItem(context, payload) {
    return axios.post(URLS.VISTORIAS_GRAVAR_DETALHE_ITEM, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gravarDetalheItem', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerItemComodo(context, payload) {
    return axios.post(URLS.VISTORIAS_REMOVER_ITEM_COMODO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('removerItemComodo', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  atualizarItemComodo(context, payload) {
    return axios.post(URLS.VISTORIAS_ATUALIZAR_ITEM_COMODO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('atualizarItemComodo', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  atualizarDescricaoDetalhe(context, payload) {
    return axios.post(URLS.VISTORIAS_ATUALIZAR_DESCRICAO_DETALHE, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar',{}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('atualizarDescricaoDetalhe', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerDetalheItem(context, payload) {
    return axios.post(URLS.VISTORIAS_REMOVER_DETALHE, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerDetalheItem', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  atualizarObservacoesGerais(context, payload) {
    return axios.post(URLS.VISTORIAS_ATUALIZAR_OBSERVACAO_GERAL, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('atualizarObservacoesGerais', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  concluirVistoria(context, payload) {
    return axios.post(URLS.VISTORIAS_CONCLUIR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('concluirVistoria', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}